/**
 * Modal utility functions
 */

class Modal {
  constructor(modalId) {
    this.modal = document.getElementById(modalId);
    if (!this.modal) {
      console.warn(`Modal with id "${modalId}" not found`);
      return;
    }

    this.overlay = this.modal.querySelector('[data-modal-overlay]');
    this.closeBtn = this.modal.querySelector('[data-modal-close]');
    this.content = this.modal.querySelector('[data-modal-content]');

    this.init();
  }

  init() {
    // Close on overlay click
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }

    // Close on close button click
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    // Close on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        this.close();
      }
    });
  }

  open() {
    this.modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  isOpen() {
    return this.modal.classList.contains('is-open');
  }

  setContent(html) {
    if (this.content) {
      this.content.innerHTML = html;
    }
  }
}

// Initialize modals when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  window.Modal = Modal;
});
